import React from "react";
import Container from "../components/wrapper/container.wrapper";
import * as Bank from "../modules/bank";
import {BankModuleStoreInterface} from "../types";
import {RouteObject} from "react-router-dom";
import ErrorBoundary from "../components/wrapper/errorBoundary.wrapper";

export const BankRouter = ({ isAuthenticated, bankStore }: {
    isAuthenticated: () => boolean,
    bankStore:  BankModuleStoreInterface
}): RouteObject => (
    {
        path: "/",
        element: <Container/>,
        children: [
            {
                path: "/bank",
                element: <Bank.List />,
                errorElement: <ErrorBoundary hasError={true} />,
            },
            {
                path: "/bank/:id/edit",
                element: <Bank.Edit />,
                errorElement: <ErrorBoundary hasError={true} />,
                loader: async ({params}: any) => {
                    if (!isAuthenticated()) {
                        return new Promise((reject) => {
                            reject(null)
                        })
                    }

                    return bankStore.prepareEditForm({ id: params.id });
                },
            },
            {
                path: "/bank/add",
                element: <Bank.Add />,
                errorElement: <ErrorBoundary hasError={true} />,
                loader: async () => {
                    if (!isAuthenticated()) {
                        return new Promise((reject) => {
                            reject(null)
                        })
                    }

                    return bankStore.prepareAddForm({});
                },
            },
            {
                path: "/bank/:id/view",
                element: <Bank.View />,
                errorElement: <ErrorBoundary hasError={true} />,
                loader: async ({params}: any) => {
                    if (!isAuthenticated()) {
                        return new Promise((reject) => {
                            reject(null)
                        })
                    }

                    return bankStore.view({ id: params.id });
                },
            },
        ]
    }
)